import { Component, Input } from '@angular/core';
import { HeterogenArea } from '../../../models/datadescription/multi/datadescription.model';
import { AxisType } from '../../../models/enums/query.enum';
import { ObjectcreatorDataManager } from '../helper/objectcreator.datamanager';

@Component({
    selector: 'heterogenArea',
    templateUrl: './heterogenArea.control.html',
    styleUrls: ['./heterogenArea.control.css']
})
export class HeterogenAreaControl {

    @Input()
    ObjectcreatorDataManager: ObjectcreatorDataManager;

    @Input()
    IsMeasuresOnAxis: boolean = false;

    @Input()
    AxisType: AxisType = AxisType.None;

    HeterogenAreaValue: HeterogenArea;
    @Input()
    get HeterogenArea() {
        return this.HeterogenAreaValue;
    }
    set HeterogenArea(value) {
        this.HeterogenAreaValue = value;
    }

    onContextMenu(event: MouseEvent, areaItemType: any) {
        event.preventDefault();
        event['AreaItemType'] = areaItemType;
    }
}
